<template>
  <div
    class="form-section"
    :class="{ [`form-section--${size}`]: size }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{ size?: string }>();
</script>

<style lang="scss" scoped>
.form-section {
  flex: 1 1 auto;
  width: 100%;
  margin: 0 math.div($grid-margin-width, 2) $pad;

  @mixin form-section-width($cols) {
    @include bp(s) {
      width: span-columns($cols);
      @include flex(0, 0);
    }
  }

  @each $size, $cols in (xs: 2, s: 4, m: 6, l: 8, xl: 10, xxl: 12) {
    &.form-section--#{$size} {
      @include form-section-width($cols);
    }
  }
}
</style>
